<template>
  <div class="add-data-dialog">
    <!-- 顶部搜索区域（固定） -->
    <div class="search-form-wrapper">
      <div class="search-form">
        <div class="search-item">
          <label>标题:</label>
          <el-input v-model="searchForm.text" placeholder="请输入标题" clearable @keyup.enter.native="handleSearch"
            @clear="handleClear"></el-input>
        </div>
        <div class="search-item">
          <label>标签:</label>
          <el-select v-model="searchForm.tagIds" placeholder="请选择标签" clearable filterable>
            <el-option v-for="tag in tagOptions" :key="tag.value" :label="tag.label" :value="tag.value"></el-option>
          </el-select>
        </div>
        <div class="search-item">
          <label>发布人:</label>
          <el-select v-model="searchForm.publisherIds" placeholder="请选择发布人" clearable filterable>
            <el-option v-for="publisher in publisherOptions" :key="publisher.value" :label="publisher.label"
              :value="publisher.value"></el-option>
          </el-select>
        </div>
        <div class="search-item">
          <label>资料类型:</label>
          <el-select v-model="searchForm.paymentType" placeholder="请选择资料类型" clearable>
            <el-option label="免费" value="FREE"></el-option>
            <el-option label="付费" value="PREMIUM"></el-option>
            <el-option label="Pro会员领取" value="VIP_PRO"></el-option>
          </el-select>
        </div>
        <div class="search-item">
          <label>排序:</label>
          <el-select v-model="searchForm.customSort" placeholder="请选择排序" clearable>
            <el-option label="按添加时间（近-远）" value="createdAt#desc"></el-option>
            <el-option label="按添加时间（远-近）" value="createdAt#asc"></el-option>
            <el-option label="按真实创建量（降序）" value="realUsageCount#desc"></el-option>
            <el-option label="按真实创建量（升序）" value="realUsageCount#asc"></el-option>
          </el-select>
        </div>
        <div class="search-buttons">
          <el-button @click="handleClear">清空</el-button>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </div>
      </div>
    </div>

    <!-- 中间表格区域（可滚动，表头固定） -->
    <div class="table-wrapper">
      <div class="table-scroll">
        <el-table ref="tableRef" :data="formattedTableData" border size="small" style="width: 100%" :height="'100%'"
          v-loading="loading" @selection-change="handleSelectionChange" @select-all="handleSelectAll" row-key="id">
          <el-table-column type="selection" width="55" fixed="left"></el-table-column>
          <el-table-column type="index" label="序号" width="60">
            <template slot-scope="scope">
              {{ (params.page - 1) * params.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="id" label="贴纸id"></el-table-column>
          <el-table-column prop="thumbnail" label="缩略图" min-width="110">
            <template slot-scope="scope">
              <el-image v-if="scope.row.thumbnail" :src="scope.row.thumbnail" fit="fill" class="table-thumbnail"
                :preview-src-list="[scope.row.thumbnail]"></el-image>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="thumbnailBadge" label="缩略图角标"></el-table-column>
          <el-table-column prop="title" label="标题" show-overflow-tooltip></el-table-column>
          <el-table-column prop="tags" label="标签" min-width="200">
            <template slot-scope="scope">
              <div class="tag-list">
                <span v-for="tag in scope.row.tagsArray" :key="tag" class="tag-pill" :title="tag">
                  {{ tag }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="slogan" label="适用设备"></el-table-column>
          <el-table-column prop="realUsageCount" label="真实创建量"></el-table-column>
          <el-table-column prop="publisherName" label="发布人"></el-table-column>
          <el-table-column prop="buttonBadge" label="按钮角标"></el-table-column>
          <el-table-column prop="paymentTypeText" label="资料类型"></el-table-column>
          <el-table-column prop="price" label="原价"></el-table-column>
          <el-table-column prop="price1" label="常规折扣价"></el-table-column>
          <el-table-column prop="price2" label="文星会员折扣价"></el-table-column>
          <el-table-column prop="price3" label="Pro会员折扣价"></el-table-column>
          <el-table-column prop="statusText" label="状态"></el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 底部分页与按钮（固定） -->
    <div class="footer-wrapper">
      <div class="footer-pagination">
        <pagination :currentPage="params.page" :pageSize="params.pageSize" :total="total" @pageNum="getPageNum" />
      </div>
      <div class="footer-buttons">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import api from "@/api";
import { valueByLanguage } from "@/utils/college";

export default {
  name: "AddDataDialog",
  components: {
    pagination
  },
  props: {
    currentCategoryId: {
      type: Number,
      default: null
    },
    moduleId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      params: {
        page: 1,
        pageSize: 20,
        status: 1 // 已上架
      },
      searchForm: {
        text: "",
        tagIds: null,
        publisherIds: null,
        paymentType: null,
        customSort: null
      },
      dataList: [],
      total: 0,
      loading: false,
      selectedData: [],
      delSelectedData: [],
      tagOptions: [],
      publisherOptions: [],
      isSyncingSelection: false
    };
  },
  computed: {
    formattedTableData() {
      const statusMap = {
        0: "待上架",
        1: "已上架",
        2: "已下架",
        3: "已永久移除"
      };
      const paymentTypeMap = {
        FREE: "免费",
        PREMIUM: "付费",
        VIP_PRO: "Pro会员领取"
      };

      return this.dataList.map((row) => {
        // 与 galaxy-admin 一致：先拿多语言对象，再取 value 显示
        const thumbnailLang = valueByLanguage(row.thumbnail, "zh_CN");
        const thumbnailBadgeLang = valueByLanguage(row.thumbnailBadge, "zh_CN");
        const titleLang = valueByLanguage(row.title, "zh_CN");
        const sloganLang = valueByLanguage(row.slogan, "zh_CN");
        const buttonBadgeLang = valueByLanguage(row.buttonBadge, "zh_CN");
        const publisherNameLang = row.publisher
          ? valueByLanguage(row.publisher.name, "zh_CN")
          : null;

        const thumbnail = (thumbnailLang && thumbnailLang.value) || "";
        const thumbnailBadge = (thumbnailBadgeLang && thumbnailBadgeLang.value) || "-";
        const title = (titleLang && titleLang.value) || "-";
        const slogan = (sloganLang && sloganLang.value) || "-";
        const buttonBadge = (buttonBadgeLang && buttonBadgeLang.value) || "-";
        const publisherName =
          (publisherNameLang && publisherNameLang.value) ||
          (row.publisher && row.publisher.name) ||
          "-";

        // 标签：处理多语言 name，取简体中文字符串
        const tagsArray = Array.isArray(row.tags)
          ? row.tags
              .map((tag) => {
                if (!tag || !tag.name) return "";
                if (Array.isArray(tag.name)) {
                  return valueByLanguage(tag.name, "zh_CN", true) || "";
                }
                return String(tag.name || "");
              })
              .filter((name) => name && name.trim())
          : [];
        const paymentInfo = row.paymentInfo || {};

        return {
          ...row,
          thumbnail: thumbnail || "",
          thumbnailBadge: thumbnailBadge || "-",
          title: title || "-",
          slogan: slogan || "-",
          buttonBadge: buttonBadge || "-",
          publisherName,
          tagsArray,
          paymentTypeText: paymentTypeMap[paymentInfo.type] || "-",
          price:
            paymentInfo.price !== null && paymentInfo.price !== undefined
              ? (paymentInfo.price / 100).toFixed(2)
              : "-",
          price1:
            paymentInfo.price1 !== null && paymentInfo.price1 !== undefined
              ? (paymentInfo.price1 / 100).toFixed(2)
              : "-",
          price2:
            paymentInfo.price2 !== null && paymentInfo.price2 !== undefined
              ? (paymentInfo.price2 / 100).toFixed(2)
              : "-",
          price3:
            paymentInfo.price3 !== null && paymentInfo.price3 !== undefined
              ? (paymentInfo.price3 / 100).toFixed(2)
              : "-",
          statusText: statusMap[row.status] || "未知",
          check: row.check !== undefined ? row.check : this.isItemSelected(row)
        };
      });
    }
  },
  mounted() {
    this.loadTagOptions();
    this.loadPublisherOptions();
    this.getList();
  },
  watch: {
    currentCategoryId() {
      this.selectedData = [];
      this.delSelectedData = [];
      this.params.page = 1;
      this.getList();
    },
    moduleId() {
      this.selectedData = [];
      this.delSelectedData = [];
      this.params.page = 1;
      this.getList();
    }
  },
  methods: {
    getList() {
      this.loading = true;
      api
        .getStickerList(this.params)
        .then((res) => {
          this.dataList = res.data.items || [];
          this.total = res.data.count || 0;
          this.setCheck();
          this.$nextTick(() => {
            this.setTableSelectionData();
          });
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err.message || "获取列表失败");
          this.loading = false;
        });
    },
    loadTagOptions() {
      api
        .getMaterialTagList({ page: 1, pageSize: 1000 })
        .then((res) => {
          this.tagOptions = (res.data.items || []).map((item) => ({
            label: valueByLanguage(item.name, "zh_CN") || "-",
            value: item.id
          }));
        })
        .catch(() => { });
    },
    loadPublisherOptions() {
      api
        .getMaterialPublisherList({ page: 1, pageSize: 1000 })
        .then((res) => {
          this.publisherOptions = (res.data.items || []).map((item) => ({
            label: valueByLanguage(item.name, "zh_CN") || "-",
            value: item.id
          }));
        })
        .catch(() => { });
    },
    getPageNum(page) {
      this.params.page = page;
      this.getList();
    },
    handleSearch() {
      this.params = {
        page: 1,
        pageSize: 20,
        status: 1
      };

      if (this.searchForm.text) {
        this.params.text = this.searchForm.text;
      }
      if (this.searchForm.tagIds) {
        this.params.tagIds = Array.isArray(this.searchForm.tagIds)
          ? this.searchForm.tagIds
          : [this.searchForm.tagIds];
      }
      if (this.searchForm.publisherIds) {
        this.params.publisherIds = Array.isArray(this.searchForm.publisherIds)
          ? this.searchForm.publisherIds
          : [this.searchForm.publisherIds];
      }
      if (this.searchForm.paymentType) {
        this.params.paymentType = this.searchForm.paymentType;
      }
      if (this.searchForm.customSort) {
        const parts = (this.searchForm.customSort || "").split("#");
        const sortBy = parts[0];
        const orderBy = parts[1];
        if (sortBy && orderBy) {
          this.params.sortBy = sortBy;
          this.params.orderBy = orderBy;
        }
      }

      this.getList();
    },
    handleClear() {
      this.searchForm = {
        text: "",
        tagIds: null,
        publisherIds: null,
        paymentType: null,
        customSort: null
      };
      this.params = {
        page: 1,
        pageSize: 20,
        status: 1
      };
      this.getList();
    },
    setCheck() {
      const targetId = this.currentCategoryId || this.moduleId;
      const listKey = this.currentCategoryId ? "categories" : (this.moduleId ? "modules" : "");
      if (!targetId || !listKey) return;
      const selectedIds = new Set(this.selectedData.map((item) => item.id));
      this.dataList.forEach((item) => {
        const list = item[listKey] || [];
        const isInTarget = list.some((el) => Number(el.id) === Number(targetId));
        item.check = isInTarget || selectedIds.has(item.id);
      });
    },
    setTableSelectionData() {
      if (!this.$refs.tableRef) return;

      this.isSyncingSelection = true;

      const tableData = this.formattedTableData;
      const selectedRows = tableData.filter(
        (row) => row.check && !this.delSelectedData.some((i) => i.id === row.id)
      );

      this.$refs.tableRef.clearSelection();
      if (selectedRows.length) {
        // 使用 setTimeout 确保表格完全渲染后再设置选中状态
        setTimeout(() => {
          selectedRows.forEach((row) => {
            this.$refs.tableRef.toggleRowSelection(row, true);
          });
          this.$nextTick(() => {
            this.isSyncingSelection = false;
          });
        }, 0);
      } else {
        this.$nextTick(() => {
          this.isSyncingSelection = false;
        });
      }
    },
    isItemSelected(item) {
      const targetId = this.currentCategoryId || this.moduleId;
      const listKey = this.currentCategoryId ? "categories" : (this.moduleId ? "modules" : "");
      if (!targetId || !listKey) return false;
      const list = item[listKey] || [];
      const inTarget = list.some((el) => Number(el.id) === Number(targetId));
      const inSelected = this.selectedData.some((i) => i.id === item.id);
      const inDel = this.delSelectedData.some((i) => i.id === item.id);
      return (inTarget || inSelected) && !inDel;
    },
    handleSelectAll(selection) {
      this.handleSelectionChange(selection);
    },
    handleSelectionChange(selection) {
      if (this.isSyncingSelection) return;
      const selectedIds = new Set((selection || []).map((item) => item.id));
      const deselectedItems = [];

      this.dataList.forEach((item) => {
        const wasSelected = this.isItemSelected(item);
        const isSelected = selectedIds.has(item.id);
        item.check = isSelected;

        if (wasSelected && !isSelected) {
          deselectedItems.push(item);
        } else if (!wasSelected && isSelected) {
          const cats = item.categories || [];
          const targetId = Number(this.currentCategoryId);
          const inCategory = cats.some((cat) => Number(cat.id) === targetId);
          if (!inCategory) {
            this.selectedData.push(item);
          }
          this.delSelectedData = this.delSelectedData.filter((i) => i.id !== item.id);
        }
      });

      this.selectedData = this.selectedData.filter(
        (item) => !deselectedItems.some((i) => i.id === item.id)
      );
      this.delSelectedData.push(...deselectedItems);
      this.delSelectedData = this.delSelectedData.filter(
        (item) => !selectedIds.has(item.id)
      );
    },
    handleConfirm() {
      if (!this.currentCategoryId) {
        this.$message.warning("请先选择分类");
        return;
      }
      this.$emit("success", {
        selectedData: this.selectedData,
        delSelectedData: this.delSelectedData
      });
    },
    handleClose() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.add-data-dialog {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.search-form-wrapper {
  flex: 0 0 auto;
  margin-bottom: 16px;
}

.search-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-item label {
  white-space: nowrap;
}

.search-item :deep(.el-input),
.search-item :deep(.el-select) {
  width: 200px;
}

.search-buttons {
  display: flex;
  gap: 10px;
  margin-left: auto;
}

.table-wrapper {
  flex: 1 1 auto;
  min-height: 0;
  border: 1px solid #ebeef5;
}

.table-scroll {
  height: 100%;
  overflow-y: auto;
  overflow-x: auto;
}

.table-scroll :deep(.el-table) {
  min-width: 1600px;
}

.table-thumbnail {
  width: 40px;
  height: 40px;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
  overflow: hidden;
}

.tag-pill {
  display: inline-block;
  max-width: 85px;
  padding: 0 6px;
  line-height: 20px;
  font-size: 12px;
  color: #67c23a;
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.footer-wrapper {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
}

.footer-pagination {
  flex: 1;
}

.footer-buttons {
  display: flex;
  gap: 10px;
}

/* 表头和单元格内容居中显示 */
.table-wrapper :deep(.el-table th .cell),
.table-wrapper :deep(.el-table td .cell) {
  text-align: center;
}
</style>
